/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGroupsDto } from '../../models/create-groups-dto';
import { StoredGroup } from '../../models/stored-group';

export interface IlsControllerSetGroups$Params {
  ilsId: string;
  
    /**
     * Groups to set
     */
    body: CreateGroupsDto
}

export function ilsControllerSetGroups(http: HttpClient, rootUrl: string, params: IlsControllerSetGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StoredGroup>>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerSetGroups.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StoredGroup>>;
    })
  );
}

ilsControllerSetGroups.PATH = '/ils/{ilsId}/groups';
